import { ref } from 'vue';
import { useLocale } from './useLocale';

import { get } from '@/api/httpClient';
import { type Region } from '@/typings/regions/Region';
import type { RegionDetails } from '@/typings/regions/RegionDetails';
import type { GetRegionsRequest } from '@/typings/requests/GetRegionsRequest';

export function useRegionsApi() {
  // GET refs
  const getAllRegionsError = ref<string | undefined>();
  const getAllRegionsLoading = ref(false);
  const getRegionDetailsByIdError = ref<string | undefined>();
  const getRegionDetailsByIdLoading = ref(false);
  const { getLocale } = useLocale();

  // GET methods
  async function getAllRegions(request?: GetRegionsRequest): Promise<Region[]> {
    getAllRegionsLoading.value = true;
    try {
      const lang = getLocale();
      return await get<any, Region[]>('/regions', { ...(request as any), locale: lang });
    } catch (err) {
      getAllRegionsError.value = err instanceof Error ? err.message : 'Unknown error';
      return [];
      //throw err; // Optionally throw to let consumers handle it further
    } finally {
      getAllRegionsLoading.value = false;
    }
  }

  async function getRegionDetailsById(id: number): Promise<RegionDetails | undefined> {
    getRegionDetailsByIdError.value = undefined;
    getRegionDetailsByIdLoading.value = true;
    try {
      const lang = getLocale();
      return await get<undefined, RegionDetails>(`/regions/details/${id}?locale=${lang}`);
    } catch (err) {
      getRegionDetailsByIdError.value = err instanceof Error ? err.message : 'Unknown error';
      console.error(getRegionDetailsByIdError.value);
      return undefined;
    } finally {
      getRegionDetailsByIdLoading.value = false;
    }
  }

  
  
  return {
    // GET returns
    getAllRegions,
    getAllRegionsError,
    getAllRegionsLoading,
    getRegionDetailsById,
    getRegionDetailsByIdError,
    getRegionDetailsByIdLoading,
  };
}
